module.exports = __webpack_public_path__ + "static/media/img-tag-moduleA1.126db7d0.png";